module.exports = __webpack_public_path__ + "img/pageBanner.553c72ee.png";